import { LocalizationHelper } from '../../helpers/localization/localization.helper';

type Keys =
  | 'title'
  | 'beta'
  | 'info'
  | 'greeting'
  | 'question'
  | 'placeholder'
  | 'loading'
  | 'loading2'
  | 'loading3'
  | 'downloadAvaliable'
  | 'speechRecognitionUnavailable'
  | 'aiAssistantError'
  | 'backendError'
  | 'downloadExpired'
  | 'timeLeft'
  | 'information'
  | 'freeCredits'
  | 'premiumCredits'
  | 'freeCreditsInfo'
  | 'premiumCreditsInfo'
  | 'creditsWarning'
  | 'learnMore';
const t = LocalizationHelper<Keys>('aiAssistant');

export const aiAssistantDe = t({
  title: 'WawiMate',
  greeting: 'Ihr KI-gestützter Assistent',
  placeholder: 'Hallo! Wie kann ich Ihnen helfen?',
  loading: 'Denke nach...',
  loading2: 'Wir bereiten die Daten für Sie vor...',
  loading3: 'Vielen Dank für Ihre Geduld...',
  downloadAvaliable: 'Download verfügbar bis:',
  speechRecognitionUnavailable:
    'Ihr Browser unterstützt möglicherweise keine Spracherkennung. Bitte geben Sie Ihre Frage unten in das Eingabefeld ein.',
  aiAssistantError:
    'Entschuldigung, ich bin nicht schlau genug, um deine Frage zu verstehen 😊 Bitte füge mehr Details hinzu und versuche es erneut.',
  backendError:
    'Entschuldigung, es ist ein Fehler aufgetreten 😔 Bitte versuchen Sie es später erneut.',
  downloadExpired: 'Download abgelaufen',
  question: 'Ihre Frage',
  info: 'Dieses Werkzeug befindet sich derzeit in fortlaufender Entwicklung.',
  beta: 'Beta',
  timeLeft: 'Restzeit',
  information: 'Info',
  freeCredits: 'Freiguthaben',
  premiumCredits: 'Premium-Guthaben',
  freeCreditsInfo:
    'Wird für grundlegende Fragen und Operationen verwendet. Diese Guthaben werden monatlich erneuert und können nicht gekauft werden.',
  premiumCreditsInfo:
    'Wird für erweiterte Analysen und KI-Funktionen verwendet. Kaufen Sie nach Bedarf mehr. Diese Guthaben verfallen nicht.',
  creditsWarning: 'werden knapp',
  learnMore: 'Mehr erfahren',
});

export const aiAssistantEn = t({
  title: 'WawiMate',
  greeting: 'Your AI-powered assistant',
  placeholder: 'Hello! How can I help you?',
  loading: 'Thinking...',
  loading2: 'We are preparing the data for you...',
  loading3: 'Thank you for your patience...',
  downloadAvaliable: 'Download available to:',
  speechRecognitionUnavailable:
    'Your browser may not support speech recognition. Please try typing your question in the input field below.',
  aiAssistantError:
    'Sorry, I’m not smart enough to understand your question 😊 Please add more details and try again.',
  backendError: 'Sorry, something went wrong 😔 Please try again later.',
  downloadExpired: 'Download expired',
  question: 'Your question',
  info: 'This tool is currently under ongoing development.',
  beta: 'Beta',
  timeLeft: 'Time left',
  information: 'Info',
  freeCredits: 'Free credits',
  premiumCredits: 'Premium credits',
  freeCreditsInfo:
    'Used for basic questions and operations. These credits renew monthly and cannot be purchased.',
  premiumCreditsInfo:
    'Used for advanced analytics and Al features. Purchase more as needed. These credits do not expire.',
  creditsWarning: 'are running low',
  learnMore: 'Learn more',
});

export const aiAssistantFr = t({
  title: 'WawiMate',
  greeting: 'Votre assistant propulsé par l’IA',
  placeholder: 'Bonjour ! Comment puis-je vous aider ?',
  loading: 'Réflexion en cours...',
  loading2: 'Nous préparons les données pour vous...',
  loading3: 'Merci pour votre patience...',
  downloadAvaliable: 'Téléchargement disponible pour :',
  speechRecognitionUnavailable:
    'Votre navigateur ne prend peut-être pas en charge la reconnaissance vocale. Veuillez saisir votre question dans le champ ci-dessous.',
  aiAssistantError:
    'Désolé, je ne suis pas assez intelligent pour comprendre votre question 😊 Veuillez ajouter plus de détails et réessayer.',
  backendError: 'Désolé, une erreur s’est produite 😔 Veuillez réessayer plus tard.',
  downloadExpired: 'Téléchargement expiré',
  question: 'Votre question',
  info: 'Cet outil est actuellement en cours de développement.',
  beta: 'Beta',
  timeLeft: 'Temps restant',
  information: 'Info',
  freeCredits: 'Crédits gratuits',
  premiumCredits: 'Crédits premium',
  freeCreditsInfo:
    'Utilisés pour les questions et opérations de base. Ces crédits se renouvellent chaque mois et ne peuvent pas être achetés.',
  premiumCreditsInfo:
    'Utilisés pour des analyses avancées et des fonctionnalités d’IA. Achetez-en plus si nécessaire. Ces crédits n’expirent pas.',
  creditsWarning: 'sont presque épuisés',
  learnMore: 'En savoir plus',
});

export const aiAssistantIt = t({
  title: 'WawiMate',
  greeting: 'Il tuo assistente potenziato dall’IA',
  placeholder: 'Ciao! Come posso aiutarti?',
  loading: 'Sto pensando...',
  loading2: 'Stiamo preparando i dati per te...',
  loading3: 'Grazie per la vostra pazienza...',
  downloadAvaliable: 'Download disponibile per:',
  speechRecognitionUnavailable:
    'Il tuo browser potrebbe non supportare il riconoscimento vocale. Prova a scrivere la tua domanda nel campo di input qui sotto.',
  aiAssistantError:
    'Mi dispiace, non sono abbastanza intelligente per capire la tua domanda 😊 Aggiungi più dettagli e riprova.',
  backendError: 'Mi dispiace, si è verificato un errore 😔 Riprova più tardi.',
  downloadExpired: 'Download scaduto',
  question: 'La tua domanda',
  info: 'Questo strumento è attualmente in fase di sviluppo continuo.',
  beta: 'Beta',
  timeLeft: 'Tempo rimanente',
  information: 'Info',
  freeCredits: 'Crediti gratuiti',
  premiumCredits: 'Crediti premium',
  freeCreditsInfo:
    'Utilizzati per domande e operazioni di base. Questi crediti si rinnovano ogni mese e non possono essere acquistati.',
  premiumCreditsInfo:
    'Utilizzati per analisi avanzate e funzionalità AI. Acquista altri crediti secondo necessità. Questi crediti non scadono.',
  creditsWarning: 'stanno per finire',
  learnMore: 'Scopri di più',
});
